import { isArray } from 'lodash-es';

export const handleCopyToClipboard = async (name?: string[] | string) => {
  const parsedName = isArray(name) ? name.join('•') : name;

  try {
    await navigator.clipboard.writeText(parsedName ?? 'unknown name');
  } catch {
    // For now, we silently ignore clipboard write errors.
  }
};
